import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InactivityTimeoutPolicyDto } from '../interfaces/inactivity-timeout-policy-dto';
import { EnterprisePolicyDto } from '../interfaces/enterprise-policy-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class InactivityTimeoutPolicyService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);

    getPolicyUrl = '';
    savePolicyUrl = '';

    constructor() {
        this.getPolicyUrl = this.env.apiUrl + '/api/v1/inactivity-timeout-policy/enterprise/';
        this.savePolicyUrl = this.env.apiUrl + '/api/v1/policy/inactivity-timeout/enterprise/';
    }

    getPolicy(enterpriseId: number): Observable<InactivityTimeoutPolicyDto> {
        return this.http.get<InactivityTimeoutPolicyDto>(`${this.getPolicyUrl}${enterpriseId}`);
    }

    savePolicy(enterpriseId: number, policy: InactivityTimeoutPolicyDto): Observable<EnterprisePolicyDto> {
        return this.http.post<EnterprisePolicyDto>(`${this.savePolicyUrl}${enterpriseId}`, policy);
    }
}

